module.exports = __webpack_public_path__ + "img/payment.695bbb95.jpg";